import { render, staticRenderFns } from "./PageGeneralText.vue?vue&type=template&id=777422a6&scoped=true&"
import script from "./PageGeneralText.vue?vue&type=script&lang=js&"
export * from "./PageGeneralText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777422a6",
  null
  
)

export default component.exports